// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3t2DI","inner":"Form_inner__1slWW","range":"Form_range__10gFo","name":"Form_name__2If8Y","actions":"Form_actions__nlq5v"};